import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { InvestpackService } from '../../../investment/investpack.service'

@Component({
  selector: 'app-direct-purchase-dialog',
  templateUrl: './direct-purchase-dialog.component.html',
  styles: [
  ]
})
export class DirectPurchaseDialogComponent implements OnInit {

  findScript = new FormControl('')
  allScripsList: any[] = []
  isLoading: boolean = false;
  selectedScrips: any[] = []
  directPurchaseForm: FormGroup

  constructor(
    private dialogRef: MatDialogRef<DirectPurchaseDialogComponent>,
    private investpackService: InvestpackService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
  }

  close(data: any){
    this.dialogRef.close()
  }

  onSearch(value: string){
    this.isLoading = true
    this.investpackService.searchInstruments(value)
      .subscribe((res)=>{
        this.allScripsList = res.data
        this.isLoading = true
      })
  }

  topdisplayFn(script: any) {
    return '';
  }

  onTopScriptSelection(event: MatAutocompleteSelectedEvent) {
    this.selectedScrips.push(event.option.value)
    this.initializeForm()
  }

  initializeForm(){
    this.directPurchaseForm = this.fb.group({
      instruments: this.fb.array([])
    })
    this.selectedScrips.forEach((instrument)=>{
      this.addInstrument(instrument)
    })
  }

  addInstrument(instrument): void {
    (this.directPurchaseForm.get('instruments') as FormArray).push(this.newInstrument(instrument));
  }

  newInstrument(instrument) {
    let form = this.fb.group({
      name: [instrument.category === 'mutual_fund' ? instrument.name : instrument.tradingSymbol, Validators.required],
      category: [instrument.category, Validators.required],
      instrument: [instrument._id, Validators.required],
      purchasePrice: [instrument.currentPrice, Validators.required],
      oldQuantity: [instrument.quantity, Validators.required],
      newQuantity: [instrument.quantity, Validators.required],
      scriptType: ['BUY']
    })
    form.controls['oldQuantity'].disable();
    return form;
  }

  getControlsArr() {
    return this.directPurchaseForm.get('instruments') as FormArray
  }

  removeScrip(index){
    (this.directPurchaseForm.get('instruments') as FormArray).removeAt(index)
  }

}
